var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"grid"},_vm._l((_vm.IDs),function(id,index){return _c('div',{key:index,staticClass:"mt-4"},[_c('preview',{attrs:{"id":id.id,"item":_vm.item,"related":_vm.related}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }